import { useDripsyTheme, useSx } from 'dripsy';
import * as React from 'react';
import { Svg } from 'react-native-svg';
export const IconBase = ({ color, width, height, children, accessibilityLabel, ...props }) => {
    const sx = useSx();
    const { theme } = useDripsyTheme();
    const colors = theme.colors;
    const resolvedColor = color ?? colors.text;
    return (React.createElement(Svg, { style: sx({
            color: resolvedColor,
        }), width: width, height: height, viewBox: "0 0 24 24", accessibilityRole: "image", accessibilityLabel: accessibilityLabel, ...props }, children));
};
//# sourceMappingURL=IconBase.js.map